import { Box, Button, HStack, Modal, Text } from 'native-base';
import Loading from '../../Common/components/Loading';
import React from 'react';
import { useMHRDocumentModal } from '../hooks/useMHRDocumentModal';
import MHRDocumentViewer from './MHRDocumentViewer';
import { useMHRDocumentAttachmentModal } from '../hooks/useDocumentAttachmentModal';

interface IDoctorMHRDocumentViewProps {
  customerID: string;
  documentID: string;
  repositoryID: string;
  onBackClicked: () => void;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorMHRDocumentView({ customerID, documentID, repositoryID, onBackClicked, onLoadDocumentCLicked }: IDoctorMHRDocumentViewProps) {
  const [attachmentFileName, setAttachmentFileName] = React.useState<string | null>(null);

  const { loading, error, ok, html } = useMHRDocumentModal(customerID, documentID, repositoryID);

  const { loading: loadingAttachment, error: errorAttachment, ok: okAttachment, html: htmlAttachment } = useMHRDocumentAttachmentModal(customerID, documentID, repositoryID, attachmentFileName);

  const loadAttachment = (attachmentFileName: string) => {
    const oidRegex = /^\d+(\.\d+){2,}\.html$/i;
    if (oidRegex.test(attachmentFileName)) {
      const documentID = attachmentFileName.replace(/\.html$/, '');
      onLoadDocumentCLicked(documentID, "");
    }
    else {
      setAttachmentFileName(attachmentFileName);
    }
  };
  return (
    <Modal.Content width="100%">
      <Modal.CloseButton />
      <Modal.Header>
        <HStack alignItems="center" justifyContent="space-between" width="100%" pr={12}>
          <Text fontSize="md" fontWeight="bold">MHR Document View</Text>
          <Button onPress={() => onBackClicked()} variant="ghost" size="sm">
            Back to list
          </Button>
        </HStack>
      </Modal.Header>
      <Modal.Body h={620}>
        {loading && <Loading />}

        {!loading && !loadingAttachment && !attachmentFileName && (
          <Box h={600} flex={1}>
            {ok && html && <MHRDocumentViewer content={html} metadata={{ title: "Clinical Document View", typeCode: "" }} onLinkClicked={loadAttachment}/>}
            {ok && !html && <Text>No content found for this document.</Text>}
            {error && <Text>{error}</Text>}
          </Box>
        )}
        {!loading && !loadingAttachment && attachmentFileName && (
          <Box h={600} flex={1}>
            {okAttachment && htmlAttachment && <MHRDocumentViewer content={htmlAttachment} metadata={{ title: "Clinical Document View", typeCode: "" }} onLinkClicked={loadAttachment}/>}
            {okAttachment && !htmlAttachment && <Text>The referenced attachment has no content to display.</Text>}
            {errorAttachment && <Text>{errorAttachment}</Text>}
          </Box>
        )}
      </Modal.Body>
    </Modal.Content>
  );
}